import { render, staticRenderFns } from "./GlobalPaymentModal.vue?vue&type=template&id=f5514742&"
import script from "./GlobalPaymentModal.vue?vue&type=script&lang=ts&"
export * from "./GlobalPaymentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports